import React, { useContext } from 'react';
import userContext from '../../components/ContextComponent/UserContext';

function Journey3(input) {
    const { formData } = useContext(userContext);
    return (
        <div>
            Thanks {formData.firstName} for applying! You have been conditionally approved for {input.props.data.journeyContent.productName} subject to additional information.
        </div>
    );
}
export default Journey3;